<!--Data about the institution and the application center.-->

<router-outlet #routerOutlet="outlet"></router-outlet>
<!-- <footer></footer> -->
<!-- <div style="font-size: xx-small">QuizzAI® test solutions.</div>
 -->



<!-- </youtube-player> -->